<template>
  <div>
    <AdminLayout class="bg-white" style="position: fixed; top:0; width: 100%;z-index: 2" :current="$c.ADMIN.TAB.WRITE" :title="$t('admin_write.write_manage_title')">
      <SearchForm v-if="is_sch_form"
                  slot="adminbar"
                  :searchValue.sync="keyword"
                  :searchType.sync="searchType"
                  :count="pageCnt"
                  @change_page="change_page"
                  @search="type_search"
                  @delete="onDelete"
                  @check="onCheckAll"
      ></SearchForm>
    </AdminLayout>
    <div class="section bg-white" align="center" style="position: fixed; top:3.5em;width: 100%; z-index: 1">
      <InputSearch v-if="tab_name == 'sale' || tab_name == 'update_sale'"
                   v-model="search_key" type="string" style="width: 80%" :placeholder='$t("site_report.search_site_name_placeholder")' @click="do_search"/>
      <InputSearch v-else
                   v-model="search_key" type="number" style="width: 80%" :placeholder='$t("admin_member.mobile_phone")' @click="do_search"/>
      <div class="align-horizontal mt-2" style="justify-content: space-between; width: 80%">
        <div v-if="tab_name == 'sale'" class="align-horizontal">
          <h6 class="mr-1">{{$t('map.classification')}}:</h6>
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            :pressed="sale_filter == key"
            @click="sale_filter = key; $refs.tab_view.sale_filter = key; do_search();"
            v-for="(key, val, idx) in $c.MF_CATEGORY" :key="idx">{{val}}</b-button>
        </div>
        <div class="align-horizontal">
          <h6 class="mr-1">{{$t('common.order_type')}}:</h6>
          <b-button
            variant="white"
            class="toggle_btn toggle_btn_text"
            :pressed="sale_order == key"
            @click="sale_order = key; $refs.tab_view.sale_order = key; do_search();"
            v-for="(key, val, idx) in $c.ORDER_TYPE" :key="idx">{{val}}</b-button>
        </div>
      </div>
      <b-nav justified fill>
        <!-- <b-nav-item>'s with child routes. Note the trailing slash on the first <b-nav-item> -->
        <b-nav-item @click="is_sch_form = false; search_key = ''; sale_order = 'ASC'; tab_name = 'update_sale';" to="/admin/write/update_sale" link-classes="tab-item" active-class="md_active">{{$t("admin.update_sale")}}</b-nav-item>
        <b-nav-item @click="is_sch_form = false; search_key = ''; sale_order = 'ASC'; sale_filter = ''; tab_name = 'sale';" to="/admin/write/sale" link-classes="tab-item" active-class="md_active">{{$t("admin.sale")}}</b-nav-item>
<!--        <b-nav-item @click="is_sch_form = true; search_key = ''; tab_name = 'notice';" to="/admin/write/notice" link-classes="tab-item" active-class="md_active">{{$t("admin.notice")}}</b-nav-item>-->
<!--        <b-nav-item @click="is_sch_form = true; search_key = ''; tab_name = 'community';" to="/admin/write/community" link-classes="tab-item" active-class="md_active">{{$t("admin.community")}}</b-nav-item>-->
      </b-nav>
    </div>
    <router-view ref="tab_view"
                 :phone="search_key"
                 :pageCnt.sync="pageCnt"
                 :searchType="searchType"
                 :keyword="keyword"
    ></router-view>
    </div>
</template>
<script>
import Utils from "../../../../config/utils";
import AdminLayout from './controls/adminlayout'
import InputSearch from './controls/input_search'
import SearchForm from './controls/search_form'

export default {
  name: "AdminWrite",
  components: {
    AdminLayout,
    InputSearch,
    SearchForm,
  },
  data() {
    return {
      is_sch_form:false,
      search_key: "",
      tab_name:'update_sale',
      pageCnt:null,
      searchType:null,
      keyword:null,
      sale_filter: '',
      sale_order: 'ASC'
    }
  },
  mounted() {
    console.log(this.tab_name);
  },
  methods:{
    do_search:function (){
      this.$refs.tab_view.getList(true);
    },
    change_page(page){
      this.$refs.tab_view.currentPage = page;
      this.$refs.tab_view.getList();
    },
    type_search(){
      this.$refs.tab_view.getList();
    },
    onCheckAll(state){
      this.$refs.tab_view.dataList = this.$refs.tab_view.dataList.map(it => {
        it.f_select = state;
        return it;
      });
    },
    onDelete(){
      let self = this;
      let selectList = this.$refs.tab_view.dataList.filter(it => {
        return it.f_select;
      }).map(it => {
          return it.f_idx;
        },
      );
      if (selectList.length < 1) {
        return;
      }
      if(this.tab_name == 'community'){
        Utils.showConfirm(
          this,
          this.$t("community.delete_confirm")
        ).then(
          value =>{
            if (value){
              Utils.requestPost(
                this.$c.API.Community.removeCommunity,
                {
                  idx_list: JSON.stringify(selectList),
                },
              ).then(result => {
                if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                  Utils.toast(this, this.$t('common.delete_success'));
                  self.$refs.tab_view.getList(true);
                } else {
                  Utils.toast(this, result.msg);
                }
              });
            }
          }
        );
      }else{
        Utils.showConfirm(
          this,
          this.$t("notify.delete_confirm")
        ).then(
          value =>{
            if (value){
              Utils.requestPost(
                this.$c.API.Notify.removeNotify,
                {
                  idx_list: JSON.stringify(selectList),
                },
              ).then(result => {
                if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                  Utils.toast(this, this.$t("common.delete_success"));
                  self.$refs.tab_view.getList(true);
                } else {
                  Utils.toast(this, result.msg);
                }
              });
            }
          }
        );
      }
    },
  },


}
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
@import '../../../../assets/css/main/more/RegNewOpenSite1.scss';
.tab-item {
  color:black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}

.md_active{
  color:$primary!important;
  border-bottom: solid 3px $primary;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminWrite.vue